import { Injectable, signal } from '@angular/core';

/**
 * Service to manage the global spinner (loading) state using Angular signals.
 *
 * This is useful for controlling a shared loading indicator across the application,
 * such as when making API calls or performing background tasks.
 */
@Injectable({ providedIn: 'root' })
export class AppUpdateState {
  /**
   * Internal signal that holds the spinner's visibility state.
   * `true` indicates that the spinner is visible; `false` means it's hidden.
   */
  private needsUpdate = signal(false);

  get updateBannerVisible(): boolean {
    return this.needsUpdate();
  }

  /**
   * Shows the update banner by setting the needsUpdate state to `true`.
   */
  showUpdateBanner(): void {
    this.needsUpdate.set(true);
  }

  /**
   * Hides the update banner by setting the needsUpdate state to `false`.
   */
  hideUpdateBanner(): void {
    this.needsUpdate.set(false);
  }
}
